
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import FilterModule from "@/store/modules/FilterModule";
import { Helpers } from "@/global-scripts/helpers";

@Component({
  components: {},
})
export default class FilterNewsToggle extends Vue {
  private filterModule = getModule(FilterModule, this.$store);

  @Prop({ default: true })
  selectable!: boolean;

  private get componentClasses(): string {
    const classes = [];

    if (this.selected) {
      classes.push("active");
    }

    return classes.join(" ");
  }

  private get selected(): boolean {
    return this.filterModule.onlyShowNews;
  }

  private get enabled(): boolean {
    return Helpers.shouldShowNewsFilter(this.filterModule.structureWeek);
  }

  private toggle() {
    if (this.selectable) {
      this.filterModule.setOnlyShowNews(!this.selected);
    }
  }
}
